import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

import BG from "../../../assets/images/boost-your-reach-image.png";

const ReachCard = () => {
  const { t } = useTranslation("ads", { keyPrefix: "reachCard" });

  return (
    <Box
      sx={{
        width: "100%",
        height: "fit-content",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "240px",
        }}
        component="img"
        src={BG}
        alt="boost-your-reach"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "20px 16px",
          height: "fit-content",
          background: "#000",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <Typography
            sx={{
              color: "var(--White, #FFF)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 750,
              lineHeight: "normal",
            }}
          >
            {t("boostYourReach")}
          </Typography>
          <Typography
            sx={{
              color: "var(--White, #FFF)",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "normal",
            }}
          >
            {t("boostDescription")}
          </Typography>
        </Box>
        <Button
          variant="secondary-md"
          sx={{
            background: "#FFF !important",
            border: "1px solid var(--Green---100, #008B07) !important",
            color: "var(--Green---100, #008B07) !important",
          }}
          disabled
        >
          {t("learnMore")}
        </Button>
      </Box>
    </Box>
  );
};

export default ReachCard;
